module.exports = __webpack_public_path__ + "static/media/banner.2e2386ad.png";